import React from "react";
import {
    Autocomplete,
    FormControlLabel,
    Switch,
    TextField,
} from "@mui/material";
import "./XplanTableFilters.css";

const XplanTableFilters = ({ filters, setFilters, xplans }) => {
    const filterXplansExcept = (excludedFilterKey) => {
        return xplans.filter(xplans => {
            for (const filterKey in filters) {
                if (filterKey === excludedFilterKey) {
                    continue;
                }

                const selectedOptions = filters[filterKey];

                if (selectedOptions?.length && !selectedOptions.some(option => xplans[filterKey]?.includes(option))
                ) {
                    return false;
                }
            }
            return true;
        });
    };

    const areaXplans = filterXplansExcept("area");
    const protocolXplans = filterXplansExcept("protocol");
    const labXplans = filterXplansExcept("labs");

    const statuses = ["Open", "Pending Documentation", "Pending Approval", "Plan Approved", "Real Time", "Future Work", "Completed", "Withdrawn", "Archived"];
    const areas = [...new Set(areaXplans.flatMap(xplan => (xplan.area ? xplan.area.split(",") : [])).map(area => area.trim()).filter(Boolean))].sort();
    const protocols = [...new Set(protocolXplans.flatMap(xplan => (xplan.protocol ? xplan.protocol.split(",") : [])).map(protocol => protocol.trim()).filter(Boolean))].sort();
    const labs = [...new Set(labXplans.map(xplan => xplan.labs))].filter(lab => lab !== null).sort();
    const types = ["Protocol Specified Studies", "Future Studies"];
    const isTSSampleRequest = filters.scopeOfWorkRequired?.[0] === "TS Sample Request";

    const handleFilterChange = (filterKey, selectedOptions) => {
        setFilters({ ...filters, [filterKey]: selectedOptions });
    };

    const handleSwitchChange = () => {
        setFilters({ ...filters, scopeOfWorkRequired: !isTSSampleRequest ? ["TS Sample Request"] : [] });
    };

    return (
        <div className="dataFilterWindow" onClick={(e) => e.stopPropagation()}>
            <div className="dataFilterGroup">
                <Autocomplete
                    multiple
                    options={statuses}
                    value={!filters.status ? [] : filters.status}
                    onChange={(_, selectedOptions) => handleFilterChange("status", selectedOptions)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={"Status"}
                            sx={{ ...(filters.status && filters.status.length && { backgroundColor: "#cceeff" }) }}
                        />
                    }
                />
            </div>
            <div className="dataFilterGroup">
                <Autocomplete
                    multiple
                    options={protocols}
                    value={!filters.protocol ? [] : filters.protocol}
                    onChange={(_, selectedOptions) => handleFilterChange("protocol", selectedOptions)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={"Study Number"}
                            sx={{ ...(filters.protocol && filters.protocol.length && { backgroundColor: "#cceeff" }) }}
                        />
                    }
                />
            </div>
            <div className="dataFilterGroup">
                <Autocomplete
                    multiple
                    options={areas}
                    value={!filters.area ? [] : filters.area}
                    onChange={(_, selectedOptions) => handleFilterChange("area", selectedOptions)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={"Area"}
                            sx={{ ...(filters.area && filters.area.length && { backgroundColor: "#cceeff" }) }}
                        />
                    }
                />
            </div>
            <div className="dataFilterGroup">
                <Autocomplete
                    multiple
                    options={labs}
                    value={!filters.labs ? [] : filters.labs}
                    onChange={(_, selectedOptions) => handleFilterChange("labs", selectedOptions)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={"Lab"}
                            sx={{ ...(filters.labs && filters.labs.length && { backgroundColor: "#cceeff" }) }}
                        />
                    }
                />
            </div>
            <div className="dataFilterGroup">
                <Autocomplete
                    multiple
                    options={types}
                    value={!filters.experimentType ? [] : filters.experimentType}
                    onChange={(_, selectedOptions) => handleFilterChange("experimentType", selectedOptions)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={"Experiment Type"}
                            sx={{ ...(filters.labs && filters.labs.length && { backgroundColor: "#cceeff" }) }}
                        />
                    }
                />
            </div>
            <div className="dataFilterGroup">
                <FormControlLabel
                    label="TS Sample Request"
                    labelPlacement="start"
                    control={
                        <Switch
                            checked={isTSSampleRequest}
                            onChange={handleSwitchChange}
                            color="primary"
                            sx={{ transform: "scale(1.2)", marginLeft: 1 }}
                        />
                    }
                    sx={{
                        ml: "12px",
                        ".MuiFormControlLabel-label": { color: "black", fontWeight: 600, fontSize: "1.2rem" },
                    }}
                />
            </div>
        </div>
    );
}

export default XplanTableFilters;